import { render, staticRenderFns } from "./dialog_doc_show.vue?vue&type=template&id=7e03ffdc&"
import script from "./dialog_doc_show.vue?vue&type=script&lang=js&"
export * from "./dialog_doc_show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports